<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold">Update Account</p>
        <v-form>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-text-field
                v-model="firstName"
                label="First Name"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-text-field
                v-model="lastName"
                label="Last Name"
                prepend-inner-icon="mdi-account"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-menu
                ref="birthdayMenuRef"
                v-model="birthdayMenu"
                :close-on-content-click="false"
                :return-value.sync="birthday"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="birthday"
                    label="Birthday"
                    prepend-inner-icon="mdi-cake-layered"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="birthdayPicker">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="birthdayMenu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.birthdayMenuRef.save(birthdayPicker)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-text-field
                v-model="contactNumber1"
                label="Primary Contact Number"
                prepend-inner-icon="mdi-cellphone"
                :rules="phMobileRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="12" sm="12" md="12">
              <v-text-field
                v-model="contactNumber2"
                label="Secondary Contact Number"
                prepend-inner-icon="mdi-cellphone"
                :rules="phMobileRules"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="finish">Update</v-btn>
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      firstName: '',
      lastName: '',
      birthday: dayjs()
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .format('YYYY-MM-DD'),
      birthdayMenu: false,
      birthdayPicker: dayjs()
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
        .format('YYYY-MM-DD'),
      contactNumber1: '',
      contactNumber2: '',
      snackbar: false,
      snackbarMessage: '',
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || 'Please use the format +63xxxxxxxxxx'
        }
      ]
    }
  },
  methods: {
    open(user) {
      this.dialog = true
      this.username = user.username
      this.firstName = user.firstName
      this.lastName = user.lastName
      this.birthday = dayjs(user.birthday).format('YYYY-MM-DD')
      this.contactNumber1 = user.contactNumber1
      this.contactNumber2 = user.contactNumber2
    },
    async finish() {
      this.loading = true
      try {
        const success = await this.$store.dispatch('auth/updateAccountAction', {
          username: this.username,
          firstName: this.firstName,
          lastName: this.lastName,
          birthday: dayjs(this.birthday).format(),
          contactNumber1: this.contactNumber1,
          contactNumber2: this.contactNumber2
        })
        this.dialog = false
        this.loading = false
        if (success) {
          this.$root
            .$confirm({
              title: 'Update Account',
              message: `Successfully Updated Account.`,
              reconfirmOnly: true,
              confirmText: 'OK',
              options: {
                color: 'primary'
              }
            })
            .then(() => {
              //this.$router.go()
              window.location.reload()
            })
        }
      } catch (err) {
        this.snackbar = true
        this.snackbarMessage = err
        this.loading = false
      }
    },
    cancel() {
      this.dialog = false
    }
  }
}
</script>
